import React, { memo } from 'react';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import '../../Static/Master/firmtable.css';


const TableBottom = ({
    totqty, totamt
}) => {

    return (
        <>
            <TableRow className='tbl-row'>

                <TableCell sx={{ p: 1, border: '1px solid #000', fontWeight: 'bold', fontSize: '1rem' }} align='center'>

                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', fontWeight: 'bold', fontSize: '1rem' }} align='center'>

                </TableCell>
                 <TableCell sx={{ p: 1, border: '1px solid #000', fontWeight: 'bold', fontSize: '1rem' }} align='center'>

                </TableCell>
              

                <TableCell sx={{ p: 1, border: '1px solid #000', fontWeight: 'bold', fontSize: '1rem' }} align='center'>

                </TableCell>
                   <TableCell sx={{ p: 1, border: '1px solid #000', fontWeight: 'bold', fontSize: '1rem' }} align='center'>

                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', fontWeight: 'bold', fontSize: '1rem' }} align='center'>
                    Total
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', fontWeight: 'bold', fontSize: '1rem' }} align='center'>
                    {totqty}
                </TableCell>
                <TableCell sx={{ p: 1, border: '1px solid #000', fontWeight: 'bold', fontSize: '1rem' }} align='center'>
                    {totamt}
                </TableCell>


                <TableCell sx={{ p: 1, border: '1px solid #000', fontWeight: 'bold', fontSize: '1rem' }} align='center'>

                </TableCell>
                <TableCell sx={{ p: 1, border: '1px solid #000', fontWeight: 'bold', fontSize: '1rem' }} align='center'>

                </TableCell>
                <TableCell sx={{ p: 1, border: '1px solid #000', fontWeight: 'bold', fontSize: '1rem' }} align='center'>

                </TableCell>
                <TableCell sx={{ p: 1, border: '1px solid #000', fontWeight: 'bold', fontSize: '1rem' }} align='center'>

                </TableCell>
                
            </TableRow>
        </>
    );
};

export default TableBottom;
